import { OrderBundleTariff } from './index';
var OrderBundle = /*@__PURE__*/ (function () {
    function OrderBundle() {
        this.opt = [];
        this.tar = new OrderBundleTariff();
        this.art = {};
        this.bnft = [];
    }
    OrderBundle.prototype.getId = function () {
        return this.id;
    };
    OrderBundle.prototype.setId = function (id) {
        this.id = id;
        return this;
    };
    OrderBundle.prototype.getQty = function () {
        return this.qty;
    };
    OrderBundle.prototype.setQty = function (qty) {
        this.qty = qty;
        return this;
    };
    OrderBundle.prototype.setArticle = function (article) {
        this.art = article;
        return this;
    };
    OrderBundle.prototype.getArticle = function () {
        return this.art;
    };
    OrderBundle.prototype.setTariff = function (tariff) {
        this.tar = tariff;
        return this;
    };
    OrderBundle.prototype.getTariff = function () {
        return this.tar;
    };
    OrderBundle.prototype.addOption = function (option) {
        this.opt.push(option);
        return this;
    };
    OrderBundle.prototype.getOptions = function () {
        return this.opt;
    };
    OrderBundle.prototype.addBenefit = function (benefit) {
        this.bnft.push(benefit);
        return this;
    };
    OrderBundle.prototype.getBenefits = function () {
        return this.bnft;
    };
    OrderBundle.prototype.setValid = function (valid) {
        this.valid = valid;
        return this;
    };
    OrderBundle.prototype.getValid = function () {
        return this.valid;
    };
    return OrderBundle;
}());
export { OrderBundle };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.bundle.ts
// module id = null
// module chunks = 